// Small pieces the admin portal's sections share (split out of AdminPortal.tsx).
import { Copy } from 'lucide-react';
import { useParent } from '../ParentContext';

// --- Families ------------------------------------------------------------------------

function timeZones(): string[] {
  try {
    return (Intl as unknown as { supportedValuesOf(k: string): string[] }).supportedValuesOf('timeZone');
  } catch {
    return [Intl.DateTimeFormat().resolvedOptions().timeZone];
  }
}
export function TimeZoneSelect({ value, onChange }: { value: string; onChange: (tz: string) => void }) {
  const zones = timeZones();
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)}>
      {!zones.includes(value) && <option value={value}>{value}</option>}
      {zones.map((z) => (
        <option key={z} value={z}>
          {z.replace(/_/g, ' ')}
        </option>
      ))}
    </select>
  );
}
/** A link the admin can copy to send by hand (shown whether or not it was also emailed). */
export function LinkResult({ url, emailed, to, what }: { url: string; emailed: boolean; to: string; what: 'invite link' | 'reset link' }) {
  const { toast } = useParent();
  return (
    <div className="notice stack link-result">
      <div className="small">
        {emailed ? `Emailed the ${what} to ${to}. ` : `Email isn’t set up, so send this ${what} to ${to} yourself. `}
        {what === 'invite link' ? 'It works for 7 days.' : 'It works for 2 hours.'}
      </div>
      <div className="row-between">
        <input className="grow mono small" readOnly value={url} onFocus={(e) => e.target.select()} aria-label="Link" />
        <button className="btn small" onClick={() => navigator.clipboard?.writeText(url).then(() => toast({ text: 'Link copied.', tone: 'good' }))}>
          <Copy size={15} /> Copy
        </button>
      </div>
    </div>
  );
}
export const dollars = (cents: number) => `$${(cents / 100).toLocaleString(undefined, { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 })}`;
export function Stat({ label, value }: { label: string; value: number }) {
  return (
    <div className="card admin-stat">
      <div className="admin-stat-value">{value}</div>
      <div className="muted small">{label}</div>
    </div>
  );
}
